import { useSelector } from "react-redux";
import { GetProjectOne } from "../../../../fnx/project/projectOne";
import { PostUploadAttachments } from "../../../../fnx/apaAuditDocuments/quoteUploadAttachtments";
import { GetQuoteOne } from "../../../../fnx/quotes/getQuoteOne";
var useSelectors = function (trigger, idQuoteParams, quoteId, projectTrigger, projectId, uploadTrigger, fileName, pdfFile, documentCode) {
    var _a = useSelector(function (state) { return ({
        responseUpdateStatusAuditDocs: state.Quote.responseUpdateStatusAuditDocs,
        errorUpdateStatusAuditDocs: state.Quote.errorUpdateStatusAuditDocs,
        loadingUpdateStatusAuditDocs: state.Quote.loadingUpdateStatusAuditDocs,
    }); }), responseUpdateStatusAuditDocs = _a.responseUpdateStatusAuditDocs, errorUpdateStatusAuditDocs = _a.errorUpdateStatusAuditDocs, loadingUpdateStatusAuditDocs = _a.loadingUpdateStatusAuditDocs;
    var _b = GetQuoteOne(trigger, idQuoteParams ? idQuoteParams : quoteId), responseOneQuote = _b.responseOneQuote, errorOneQuote = _b.errorOneQuote, loadingOneQuote = _b.loadingOneQuote;
    var _c = GetProjectOne(projectTrigger, projectId), responseOneProject = _c.responseOneProject, errorOneProject = _c.errorOneProject, loadingOneProject = _c.loadingOneProject;
    var _d = PostUploadAttachments(uploadTrigger, idQuoteParams ? idQuoteParams : quoteId, fileName, pdfFile, documentCode), responseUploadAttach = _d.responseUploadAttach, errorUploadAttach = _d.errorUploadAttach, loadingUploadAttach = _d.loadingUploadAttach;
    return {
        responseUpdateStatusAuditDocs: responseUpdateStatusAuditDocs,
        errorUpdateStatusAuditDocs: errorUpdateStatusAuditDocs,
        loadingUpdateStatusAuditDocs: loadingUpdateStatusAuditDocs,
        responseOneQuote: responseOneQuote,
        errorOneQuote: errorOneQuote,
        loadingOneQuote: loadingOneQuote,
        responseOneProject: responseOneProject,
        errorOneProject: errorOneProject,
        loadingOneProject: loadingOneProject,
        responseUploadAttach: responseUploadAttach,
        errorUploadAttach: errorUploadAttach,
        loadingUploadAttach: loadingUploadAttach,
    };
};
export default useSelectors;
